import { IssueFragment, IssueFragmentQuery } from '../../utils/gqlModels';
import {
  AddIncorrectTimeNoteFunction,
  checkIssueIncorrectTimeNotes,
  issueMapFunction,
} from '../../utils/issueUtils';
import { Issue, Project } from '../../utils/model';
import { graphqlQuery } from './_graphqlQuery';

const getIssueQuery = (validateNotes: boolean) => `
${IssueFragmentQuery(validateNotes)}
query issue($id: IssueID!) {
  issue(id:$id){
    ...IssueFragment
  }
}
`;

interface GetIssueQueryGqlResponse {
  issue: IssueFragment;
}

export const getIssueById = async ({
  addIncorrectTimeNote,
  validateNotes,
  projects,
  from,
  id,
  to,
}: {
  addIncorrectTimeNote: AddIncorrectTimeNoteFunction;
  projects: Project[];
  validateNotes: boolean;
  id: string;
  from: Date;
  to: Date;
}): Promise<Issue | undefined> => {
  const data = await graphqlQuery<GetIssueQueryGqlResponse>(
    getIssueQuery(validateNotes),
    {
      id,
    },
  );

  if (!data.issue) {
    return;
  }
  const project = projects.find((p) => p.id === Number(data.issue.projectId));
  if (!project) return;
  checkIssueIncorrectTimeNotes({
    addIncorrectTimeNote,
    issues: [data.issue],
    from,
    to,
    project,
    projects,
  });
  return issueMapFunction({ project, projects })(data.issue);
};
